import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import { Form, Input, DatePicker, notification, Icon, Select, Tooltip } from "antd";
import { GlobalContext } from "../../app/providers/GlobalState";
import axios from "axios";
import moment from "moment";
import { noimage } from "../../assets";

const { Option } = Select;
const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

class DadosGerais extends Component {
    static contextType = GlobalContext;
    state = {
        //FOTO UTILIZADOR
        foto: "",
        preview: null,
        //DADOS GERAIS
        nome_completo: "",
        emailnotif: "",
        contacto: "",
        descricao: "",
        habilitacao: "",
        paginaPessoal: "",
        dt_nascimento: null,
        naturalidade: "",
        sexo: "",
        estadoCivil: "",
        cc: "",
        dt_ccvalidade: null,
        nif: "",
        cep: "",
        localidade: "",
        morada: "",
        pais: "",
        //FILIAÇÃO
        maeResponsavel: "",
        maeProfissao: "",
        paiResponsavel: "",
        paiProfissao: "",
        //RESPONSAVEL
        responsavelNome: "",
        responsavelEmail: "",
        responsavelContacto: "",
        podeAlterarDadosPessoais: false,
        //UPLOAD VALIDATE
        totalBytes: 0,
        formatoValido: true,
        validateStatus: "",
        help: "",
        //LOADING
        iconLoading: false,
        //REDIRECT
        redirect: false,
        redirectLink: ""
    };

    componentDidUpdate() {
        if (!this.context.is_authenticated)
            this.setState({
                redirect: true,
                redirectLink: "/login"
            });
    }

    //CHAMADA ANTES DO RENDER
    UNSAFE_componentWillMount() {
        this.carregarDadosPerfil();
    }

    handleChangeSelect = value => {
        this.setState({ pais: value });
    };

    handleChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleChangeDataNascimento = date => {
        this.setState({ dt_nascimento: date });
    };

    handleChangeDate = date => {
        this.setState({ dt_ccvalidade: date });
    };

    //ATUALIZA A FOTO
    uploadFoto = event => {
        if (event.target.files[0].size < 100 * 1024)
            if (this.validarFormatoImagem(event.target.files[0].name.split(".").pop().toLowerCase())) {
                this.setState({
                    totalBytes: event.target.files[0].size,
                    formatoValido: true,
                    validateStatus: "",
                    help: "",
                    foto: event.target.files[0],
                    preview: URL.createObjectURL(event.target.files[0])
                });
            } else {
                document.getElementById("input-foto").value = "";
                openNotificationWithIcon("error", "Erro", "Ficheiro com formato inválido");
            }
        else {
            document.getElementById("input-foto").value = "";
            openNotificationWithIcon("error", "Erro", "Limite de 100 KB para a ficheiro.");
        }
    };

    //VALIDA O TIPO DE FICHEIRO COM OS FORMATOS ACEITES
    validarFormatoImagem = formato => {
        var formatos = ["jpg", "jpeg", "png", "gif"];
        var valido = false;
        for (var i = 0; i < formatos.length; i++) {
            if (formato.toLowerCase() === formatos[i]) {
                valido = true;
                break;
            }
        }
        return valido;
    };

    //ABRE O FILE BROWSER
    ativarUploadFoto = () => {
        document.getElementById("input-foto").click();
    };

    //REMOVE A FOTO
    removerFoto = () => {
        document.getElementById("input-foto").value = "";
        this.setState({
            foto: "",
            preview: ""
        });
    };

    //CARREGA OS DADOS DO UTILIZADOR
    carregarDadosPerfil = () => {
        axios({
            method: "get",
            url: "/api/minha-conta"
        })
            .then(response => {
                this.context.atualizarState({
                    nr_utilizador: response.data.nr_aluno,
                    dt_adesao_utilizador: response.data.dt_criado,
                    login2: response.data.login2,
                    email: response.data.email,
                    nome_apelido: response.data.nome_apelido,
                    organismo: response.data.organismo,
                    medalhasCurso: response.data.medalhasCurso,
                    medalhasTarefa: response.data.medalhasTarefa
                });

                this.setState({
                    //FOTO UTILIZADOR
                    foto: response.data.foto,
                    preview: response.data.foto,
                    //DADOS GERAIS
                    nome_completo: response.data.nome_completo,
                    emailnotif: response.data.emailnotif,
                    contacto: response.data.contacto ? response.data.contacto : "",
                    descricao: response.data.descricao ? response.data.descricao : "",
                    habilitacao: response.data.habilitacao ? response.data.habilitacao : "",
                    paginaPessoal: response.data.paginaPessoal ? response.data.paginaPessoal : "",
                    dt_nascimento: response.data.dt_nascimento ? moment(response.data.dt_nascimento) : null,
                    naturalidade: response.data.naturalidade ? response.data.naturalidade : "",
                    sexo: response.data.sexo ? response.data.sexo : undefined,
                    estadoCivil: response.data.estado_civil ? response.data.estado_civil : undefined,
                    cc: response.data.cc ? response.data.cc : "",
                    dt_ccvalidade: response.data.dt_ccvalidade ? moment(response.data.dt_ccvalidade) : null,
                    nif: response.data.nif ? response.data.nif : "",
                    cep: response.data.cep ? response.data.cep : "",
                    localidade: response.data.localidade ? response.data.localidade : "",
                    morada: response.data.morada ? response.data.morada : "",
                    pais: response.data.pais ? response.data.pais : "",
                    //FILIAÇÃO
                    paiResponsavel: response.data.responsavel_1 ? response.data.responsavel_1 : "",
                    paiProfissao: response.data.responsavel_profissao_1 ? response.data.responsavel_profissao_1 : "",
                    maeResponsavel: response.data.responsavel_2 ? response.data.responsavel_2 : "",
                    maeProfissao: response.data.responsavel_profissao_2 ? response.data.responsavel_profissao_2 : "",
                    //RESPONSAVEL
                    responsavelNome: response.data.responsavel_nome ? response.data.responsavel_nome : "",
                    responsavelEmail: response.data.responsavel_email ? response.data.responsavel_email : "",
                    responsavelContacto: response.data.responsavel_contacto ? response.data.responsavel_contacto : "",
                    //PERMISSOES
                    podeAlterarDadosPessoais: response.data.pode_alterar_dados_pessoais
                });
            })
            .catch(error => {
                if (error.response.status === 401)
                    this.setState({
                        redirect: true,
                        redirectLink: "/login"
                    });
            });
    };

    atualizarDados = event => {
        event.preventDefault();

        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err && this.state.totalBytes <= 100 * 1024 && this.state.formatoValido) {
                this.setState({ iconLoading: true });

                var item = new FormData();
                item.append("foto", this.state.foto);
                item.append("nome_completo", this.state.nome_completo);
                item.append("emailnotif", this.state.emailnotif);
                item.append("contacto", this.state.contacto);
                item.append("descricao", this.state.descricao);
                item.append("habilitacao", this.state.habilitacao);
                item.append("paginaPessoal", this.state.paginaPessoal);
                if (this.state.dt_nascimento) item.append("dt_nascimento", this.state.dt_nascimento.format("YYYY/MM/DD"));
                item.append("naturalidade", this.state.naturalidade);
                if (this.state.sexo) item.append("sexo", this.state.sexo);
                if (this.state.estadoCivil) item.append("estado_civil", this.state.estadoCivil);
                item.append("cc", this.state.cc);
                if (this.state.dt_ccvalidade) item.append("dt_ccvalidade", this.state.dt_ccvalidade.format("YYYY/MM/DD"));
                item.append("nif", this.state.nif);
                item.append("cep", this.state.cep);
                item.append("localidade", this.state.localidade);
                item.append("morada", this.state.morada);
                item.append("pais", this.state.pais);
                //FILIAÇÃO
                item.append("responsavel_1", this.state.paiResponsavel);
                item.append("responsavel_profissao_1", this.state.paiProfissao);
                item.append("responsavel_2", this.state.paiResponsavel);
                item.append("responsavel_profissao_2", this.state.maeProfissao);
                //RESPONSAVEL
                item.append("responsavel_nome", this.state.responsavelNome);
                item.append("responsavel_email", this.state.responsavelEmail);
                item.append("responsavel_contacto", this.state.responsavelContacto);

                axios({
                    method: "put",
                    url: "/api/minha-conta",
                    data: item
                })
                    .then(() => {
                        this.context.atualizarState({ atualizarDadosGerias: true });
                        openNotificationWithIcon("success", "Sucesso", "Dados atualizados!");
                        this.setState({
                            iconLoading: false
                        });
                    })
                    .catch(error => {
                        openNotificationWithIcon("error", "Erro", error.response.data);
                        this.setState({
                            iconLoading: false
                        });
                    });
            }
        });
    };

    disabledDate = current => {
        return current && current > moment().endOf("day");
    };

    validarLink = (rule, value, callback) => {
        var pattern = new RegExp(
            "^(https?:\\/\\/)?" +
                "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" +
                "((\\d{1,3}\\.){3}\\d{1,3}))" +
                "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" +
                "(\\?[;&a-z\\d%_.~+=-]*)?" +
                "(\\#[-a-z\\d_]*)?$",
            "i"
        );
        if (!pattern.test(value) && value) callback("Introduza uma página válida");

        callback();
    };

    render() {
        const { TextArea } = Input;
        const { getFieldDecorator } = this.props.form;
        const {
            //FOTO UTILIZADOR
            preview,
            //DADOS GERAIS
            nome_completo,
            emailnotif,
            contacto,
            descricao,
            habilitacao,
            paginaPessoal,
            dt_nascimento,
            naturalidade,
            sexo,
            estadoCivil,
            cc,
            dt_ccvalidade,
            nif,
            cep,
            localidade,
            morada,
            pais,
            //FILIAÇÃO
            maeResponsavel,
            maeProfissao,
            paiResponsavel,
            paiProfissao,
            //RESPONSAVEL
            responsavelNome,
            responsavelEmail,
            responsavelContacto,
            //PERMISSOES
            podeAlterarDadosPessoais,
            //UPLOAD VALIDATE
            validateStatus,
            help,
            //LOADING
            iconLoading,
            //REDIRECT
            redirect,
            redirectLink
        } = this.state;

        if (redirect) return <Redirect to={redirectLink} />;

        return (
            <div className="bloco-minha-conta">
                <div className="dados-pessoais">
                    <div className="bloco-img">
                        <Form>
                            <Form.Item validateStatus={validateStatus} help={help}>
                                <div className="container-img">
                                    <img src={preview ? preview : noimage} />
                                </div>
                                <input
                                    type="file"
                                    id="input-foto"
                                    accept="image/*"
                                    onChange={this.uploadFoto}
                                    style={{ display: "none" }}
                                />
                                {podeAlterarDadosPessoais && (
                                    <>
                                        {!preview ? (
                                            <>
                                                <Link to="#" className="link-principal-border" onClick={this.ativarUploadFoto}>
                                                    <span>Adicionar</span>
                                                </Link>{" "}
                                                <Tooltip
                                                    className="info-icon"
                                                    title={
                                                        <>
                                                            <p>Tamanho máximo: 100KB</p>
                                                            <p>Tamanho recomendado: 200x200px</p>
                                                            <p>Formatos válidos: .gif, .jpg, .jpeg, .png</p>
                                                        </>
                                                    }
                                                >
                                                    <Icon type="question-circle-o" />
                                                </Tooltip>
                                            </>
                                        ) : (
                                            <>
                                                <Link to="#" className="link-principal-border" onClick={this.ativarUploadFoto}>
                                                    <span>Alterar</span>
                                                </Link>
                                                <Tooltip
                                                    className="info-icon"
                                                    title={
                                                        <>
                                                            <p>Tamanho máximo: 100KB</p>
                                                            <p>Tamanho recomendado: 200x200px</p>
                                                            <p>Formatos válidos: .gif, .jpg, .jpeg, .png</p>
                                                        </>
                                                    }
                                                >
                                                    <Icon type="question-circle-o" style={{ marginRight: 20 }} />
                                                </Tooltip>
                                                <Link to="#" className="link-principal-border" onClick={this.removerFoto}>
                                                    <span>Remover</span>
                                                </Link>
                                            </>
                                        )}
                                    </>
                                )}
                            </Form.Item>
                        </Form>
                    </div>
                    <div className="bloco-info">
                        <Form className="minha-conta">
                            <div className="bloco">
                                <Form.Item label="Nome Completo">
                                    {getFieldDecorator("nome-completo", {
                                        rules: [
                                            {
                                                required: true,
                                                message: "Campo obrigatório",
                                                whitespace: true
                                            }
                                        ],
                                        initialValue: nome_completo
                                    })(<Input name="nome_completo" disabled={!podeAlterarDadosPessoais} onChange={this.handleChange} />)}
                                </Form.Item>
                                <Form.Item
                                    label={
                                        <>
                                            E-mail{" "}
                                            <Tooltip
                                                className="info-icon"
                                                className="info-icon info-icon2"
                                                title="E-mail usado para as notificações..."
                                            >
                                                <Icon type="question-circle-o" />
                                            </Tooltip>
                                        </>
                                    }
                                    className="input-50"
                                >
                                    {getFieldDecorator("email", {
                                        rules: [
                                            {
                                                type: "email",
                                                message: "Introduza um endereço de e-mail válido"
                                            },
                                            {
                                                required: false
                                            }
                                        ],
                                        initialValue: emailnotif
                                    })(
                                        <Input
                                            name="emailnotif"
                                            enabled="true"
                                            disabled={!podeAlterarDadosPessoais}
                                            onChange={this.handleChange}
                                        />
                                    )}
                                </Form.Item>
                                <Form.Item label="Telefone / Celular">
                                    <Input
                                        value={contacto}
                                        name="contacto"
                                        className="input-25"
                                        disabled={!podeAlterarDadosPessoais}
                                        onChange={this.handleChange}
                                    />
                                </Form.Item>
                                <Form.Item
                                    label={
                                        <>
                                            Breve Descrição{" "}
                                            <Tooltip className="info-icon info-icon2" title="Resumo sucinto sobre a minha pessoa...">
                                                <Icon type="question-circle-o" />
                                            </Tooltip>
                                        </>
                                    }
                                >
                                    <TextArea
                                        value={descricao}
                                        name="descricao"
                                        onChange={this.handleChange}
                                        rows={4}
                                        style={{ height: 100 }}
                                        disabled={!podeAlterarDadosPessoais}
                                    />
                                </Form.Item>
                                <Form.Item label="Habilitações">
                                    <TextArea
                                        value={habilitacao}
                                        name="habilitacao"
                                        onChange={this.handleChange}
                                        rows={3}
                                        style={{ height: 100 }}
                                        disabled={!podeAlterarDadosPessoais}
                                    />
                                </Form.Item>
                                <Form.Item label="Página Web pessoal">
                                    {getFieldDecorator("paginaPessoal", {
                                        rules: [
                                            {
                                                validator: this.validarLink
                                            }
                                        ],
                                        initialValue: paginaPessoal
                                    })(<Input name="paginaPessoal" disabled={!podeAlterarDadosPessoais} onChange={this.handleChange} />)}
                                </Form.Item>
                                <Form.Item label="Data de nascimento">
                                    {getFieldDecorator("dt_nascimento", {
                                        initialValue: dt_nascimento
                                    })(
                                        <DatePicker
                                            className="input-25"
                                            placeholder="Selecionar"
                                            format="DD-MM-YYYY"
                                            name="dt_nascimento"
                                            onChange={this.handleChangeDataNascimento}
                                            disabledDate={this.disabledDate}
                                            disabled={!podeAlterarDadosPessoais}
                                        />
                                    )}
                                </Form.Item>
                                <Form.Item label="Naturalidade">
                                    <Input
                                        value={naturalidade}
                                        name="naturalidade"
                                        className="input-50"
                                        disabled={!podeAlterarDadosPessoais}
                                        onChange={this.handleChange}
                                    />
                                </Form.Item>
                                <Form.Item label="Sexo">
                                    <Select
                                        className="input-25"
                                        placeholder="Selecionar"
                                        name="certificacao"
                                        allowClear={true}
                                        value={sexo}
                                        onChange={sexo => this.setState({ sexo })}
                                        disabled={!podeAlterarDadosPessoais}
                                    >
                                        <Option value="MASCULINO">Masculino</Option>
                                        <Option value="FEMININO">Feminino</Option>
                                    </Select>
                                </Form.Item>
                                <Form.Item label="Estado Civil">
                                    {getFieldDecorator("estadoCivil", {
                                        initialValue: estadoCivil
                                    })(
                                        <Select
                                            className="input-50"
                                            placeholder="Selecionar"
                                            allowClear={true}
                                            onChange={estadoCivil =>
                                                this.setState({
                                                    estadoCivil
                                                })
                                            }
                                            disabled={!podeAlterarDadosPessoais}
                                        >
                                            <Option key="Solteiro(a)">Solteiro(a)</Option>
                                            <Option key="Casado(a)">Casado(a)</Option>
                                            <Option key="Viúvo(a)">Viúvo(a)</Option>
                                            <Option key="Separado(a) Judicialmente">Separado(a) Judicialmente</Option>
                                            <Option key="Divorciado(a)">Divorciado(a)</Option>
                                            <Option key="Outro">Outro</Option>
                                        </Select>
                                    )}
                                </Form.Item>
                                <Form.Item
                                    label={
                                        <>
                                            Identificação / RG
                                            <Tooltip className="info-icon" title="Documento de Identificação, Passaporte, ...">
                                                <Icon type="question-circle-o" />
                                            </Tooltip>
                                        </>
                                    }
                                >
                                    <Input
                                        value={cc}
                                        name="cc"
                                        className="input-50"
                                        disabled={!podeAlterarDadosPessoais}
                                        onChange={this.handleChange}
                                    />
                                </Form.Item>
                                <Form.Item
                                    label={
                                        <>
                                            Validade
                                            <Tooltip className="info-icon" title="Validade do documento de identificação">
                                                <Icon type="question-circle-o" />
                                            </Tooltip>
                                        </>
                                    }
                                >
                                    <DatePicker
                                        className="input-25"
                                        placeholder="Selecionar"
                                        format="DD-MM-YYYY"
                                        name="dt_ccvalidade"
                                        value={dt_ccvalidade}
                                        onChange={this.handleChangeDate}
                                        disabled={!podeAlterarDadosPessoais}
                                    />
                                </Form.Item>
                                <Form.Item label="Dados Fiscais / CPF">
                                    <Input
                                        value={nif}
                                        name="nif"
                                        className="input-25"
                                        disabled={!podeAlterarDadosPessoais}
                                        onChange={this.handleChange}
                                    />
                                </Form.Item>
                                <Form.Item label="Código Postal / CEP">
                                    <Input
                                        value={cep}
                                        name="cep"
                                        className="input-25"
                                        disabled={!podeAlterarDadosPessoais}
                                        onChange={this.handleChange}
                                    />
                                </Form.Item>
                                <Form.Item label="Localidade / Estado">
                                    <Input
                                        value={localidade}
                                        name="localidade"
                                        className="input-50"
                                        disabled={!podeAlterarDadosPessoais}
                                        onChange={this.handleChange}
                                    />
                                </Form.Item>
                                <Form.Item label="Endereço">
                                    <TextArea
                                        value={morada}
                                        name="morada"
                                        disabled={!podeAlterarDadosPessoais}
                                        onChange={this.handleChange}
                                        rows={4}
                                        style={{ height: 100 }}
                                    />
                                </Form.Item>
                                <Form.Item label="País">
                                    <Select
                                        className="input-25 selecionar-pais"
                                        showSearch
                                        placeholder="Selecionar"
                                        value={pais}
                                        allowClear={true}
                                        onChange={this.handleChangeSelect}
                                        disabled={!podeAlterarDadosPessoais}
                                    >
                                        <Option value="África do Sul">África do Sul</Option>
                                        <Option value="Albânia">Albânia</Option>
                                        <Option value="Alemanha">Alemanha</Option>
                                        <Option value="Andorra">Andorra</Option>
                                        <Option value="Angola">Angola</Option>
                                        <Option value="Anguilla">Anguilla</Option>
                                        <Option value="Antigua">Antigua</Option>
                                        <Option value="Arábia Saudita">Arábia Saudita</Option>
                                        <Option value="Argentina">Argentina</Option>
                                        <Option value="Armênia">Armênia</Option>
                                        <Option value="Aruba">Aruba</Option>
                                        <Option value="Austrália">Austrália</Option>
                                        <Option value="Áustria">Áustria</Option>
                                        <Option value="Azerbaijão">Azerbaijão</Option>
                                        <Option value="Bahamas">Bahamas</Option>
                                        <Option value="Bahrein">Bahrein</Option>
                                        <Option value="Bangladesh">Bangladesh</Option>
                                        <Option value="Barbados">Barbados</Option>
                                        <Option value="Bélgica">Bélgica</Option>
                                        <Option value="Benin">Benin</Option>
                                        <Option value="Bermudas">Bermudas</Option>
                                        <Option value="Botsuana">Botsuana</Option>
                                        <Option value="Brasil" selected>
                                            Brasil
                                        </Option>
                                        <Option value="Brunei">Brunei</Option>
                                        <Option value="Bulgária">Bulgária</Option>
                                        <Option value="Burkina Fasso">Burkina Fasso</Option>
                                        <Option value="botão">botão</Option>
                                        <Option value="Cabo Verde">Cabo Verde</Option>
                                        <Option value="Camarões">Camarões</Option>
                                        <Option value="Camboja">Camboja</Option>
                                        <Option value="Canadá">Canadá</Option>
                                        <Option value="Cazaquistão">Cazaquistão</Option>
                                        <Option value="Chade">Chade</Option>
                                        <Option value="Chile">Chile</Option>
                                        <Option value="China">China</Option>
                                        <Option value="Cidade do Vaticano">Cidade do Vaticano</Option>
                                        <Option value="Colômbia">Colômbia</Option>
                                        <Option value="Congo">Congo</Option>
                                        <Option value="Coréia do Sul">Coréia do Sul</Option>
                                        <Option value="Costa do Marfim">Costa do Marfim</Option>
                                        <Option value="Costa Rica">Costa Rica</Option>
                                        <Option value="Croácia">Croácia</Option>
                                        <Option value="Dinamarca">Dinamarca</Option>
                                        <Option value="Djibuti">Djibuti</Option>
                                        <Option value="Dominica">Dominica</Option>
                                        <Option value="EUA">EUA</Option>
                                        <Option value="Egito">Egito</Option>
                                        <Option value="El Salvador">El Salvador</Option>
                                        <Option value="Emirados Árabes">Emirados Árabes</Option>
                                        <Option value="Equador">Equador</Option>
                                        <Option value="Eritréia">Eritréia</Option>
                                        <Option value="Escócia">Escócia</Option>
                                        <Option value="Eslováquia">Eslováquia</Option>
                                        <Option value="Eslovênia">Eslovênia</Option>
                                        <Option value="Espanha">Espanha</Option>
                                        <Option value="Estônia">Estônia</Option>
                                        <Option value="Etiópia">Etiópia</Option>
                                        <Option value="Fiji">Fiji</Option>
                                        <Option value="Filipinas">Filipinas</Option>
                                        <Option value="Finlândia">Finlândia</Option>
                                        <Option value="França">França</Option>
                                        <Option value="Gabão">Gabão</Option>
                                        <Option value="Gâmbia">Gâmbia</Option>
                                        <Option value="Gana">Gana</Option>
                                        <Option value="Geórgia">Geórgia</Option>
                                        <Option value="Gibraltar">Gibraltar</Option>
                                        <Option value="Granada">Granada</Option>
                                        <Option value="Grécia">Grécia</Option>
                                        <Option value="Guadalupe">Guadalupe</Option>
                                        <Option value="Guam">Guam</Option>
                                        <Option value="Guatemala">Guatemala</Option>
                                        <Option value="Guiana">Guiana</Option>
                                        <Option value="Guiana Francesa">Guiana Francesa</Option>
                                        <Option value="Guiné-bissau">Guiné-bissau</Option>
                                        <Option value="Haiti">Haiti</Option>
                                        <Option value="Holanda">Holanda</Option>
                                        <Option value="Honduras">Honduras</Option>
                                        <Option value="Hong Kong">Hong Kong</Option>
                                        <Option value="Hungria">Hungria</Option>
                                        <Option value="Iêmen">Iêmen</Option>
                                        <Option value="Ilhas Cayman">Ilhas Cayman</Option>
                                        <Option value="Ilhas Cook">Ilhas Cook</Option>
                                        <Option value="Ilhas Curaçao">Ilhas Curaçao</Option>
                                        <Option value="Ilhas Marshall">Ilhas Marshall</Option>
                                        <Option value="Ilhas Turks & Caicos">Ilhas Turks & Caicos</Option>
                                        <Option value="Ilhas Virgens (brit.)">Ilhas Virgens (brit.)</Option>
                                        <Option value="Ilhas Virgens(amer.)">Ilhas Virgens(amer.)</Option>
                                        <Option value="Ilhas Wallis e Futuna">Ilhas Wallis e Futuna</Option>
                                        <Option value="Índia">Índia</Option>
                                        <Option value="Indonésia">Indonésia</Option>
                                        <Option value="Inglaterra">Inglaterra</Option>
                                        <Option value="Irlanda">Irlanda</Option>
                                        <Option value="Islândia">Islândia</Option>
                                        <Option value="Israel">Israel</Option>
                                        <Option value="Itália">Itália</Option>
                                        <Option value="Jamaica">Jamaica</Option>
                                        <Option value="Japão">Japão</Option>
                                        <Option value="Jordânia">Jordânia</Option>
                                        <Option value="Kuwait">Kuwait</Option>
                                        <Option value="Latvia">Latvia</Option>
                                        <Option value="Líbano">Líbano</Option>
                                        <Option value="Liechtenstein">Liechtenstein</Option>
                                        <Option value="Lituânia">Lituânia</Option>
                                        <Option value="Luxemburgo">Luxemburgo</Option>
                                        <Option value="Macau">Macau</Option>
                                        <Option value="Macedônia">Macedônia</Option>
                                        <Option value="Madagascar">Madagascar</Option>
                                        <Option value="Malásia">Malásia</Option>
                                        <Option value="Malaui">Malaui</Option>
                                        <Option value="Mali">Mali</Option>
                                        <Option value="Malta">Malta</Option>
                                        <Option value="Marrocos">Marrocos</Option>
                                        <Option value="Martinica">Martinica</Option>
                                        <Option value="Mauritânia">Mauritânia</Option>
                                        <Option value="Mauritius">Mauritius</Option>
                                        <Option value="México">México</Option>
                                        <Option value="Moldova">Moldova</Option>
                                        <Option value="Mônaco">Mônaco</Option>
                                        <Option value="Montserrat">Montserrat</Option>
                                        <Option value="Nepal">Nepal</Option>
                                        <Option value="Nicarágua">Nicarágua</Option>
                                        <Option value="Niger">Niger</Option>
                                        <Option value="Nigéria">Nigéria</Option>
                                        <Option value="Noruega">Noruega</Option>
                                        <Option value="Nova Caledônia">Nova Caledônia</Option>
                                        <Option value="Nova Zelândia">Nova Zelândia</Option>
                                        <Option value="Omã">Omã</Option>
                                        <Option value="Palau">Palau</Option>
                                        <Option value="Panamá">Panamá</Option>
                                        <Option value="Papua-nova Guiné">Papua-nova Guiné</Option>
                                        <Option value="Paquistão">Paquistão</Option>
                                        <Option value="Peru">Peru</Option>
                                        <Option value="Polinésia Francesa">Polinésia Francesa</Option>
                                        <Option value="Polônia">Polônia</Option>
                                        <Option value="Porto Rico">Porto Rico</Option>
                                        <Option value="Portugal">Portugal</Option>
                                        <Option value="Qatar">Qatar</Option>
                                        <Option value="Quênia">Quênia</Option>
                                        <Option value="Rep. Dominicana">Rep. Dominicana</Option>
                                        <Option value="Rep. Tcheca">Rep. Tcheca</Option>
                                        <Option value="Reunion">Reunion</Option>
                                        <Option value="Romênia">Romênia</Option>
                                        <Option value="Ruanda">Ruanda</Option>
                                        <Option value="Rússia">Rússia</Option>
                                        <Option value="Saipan">Saipan</Option>
                                        <Option value="Samoa Americana">Samoa Americana</Option>
                                        <Option value="Senegal">Senegal</Option>
                                        <Option value="Serra Leone">Serra Leone</Option>
                                        <Option value="Seychelles">Seychelles</Option>
                                        <Option value="Singapura">Singapura</Option>
                                        <Option value="Síria">Síria</Option>
                                        <Option value="Sri Lanka">Sri Lanka</Option>
                                        <Option value="St. Kitts & Nevis">St. Kitts & Nevis</Option>
                                        <Option value="St. Lúcia">St. Lúcia</Option>
                                        <Option value="St. Vincent">St. Vincent</Option>
                                        <Option value="Sudão">Sudão</Option>
                                        <Option value="Suécia">Suécia</Option>
                                        <Option value="Suiça">Suiça</Option>
                                        <Option value="Suriname">Suriname</Option>
                                        <Option value="Tailândia">Tailândia</Option>
                                        <Option value="Taiwan">Taiwan</Option>
                                        <Option value="Tanzânia">Tanzânia</Option>
                                        <Option value="Togo">Togo</Option>
                                        <Option value="Trinidad & Tobago">Trinidad & Tobago</Option>
                                        <Option value="Tunísia">Tunísia</Option>
                                        <Option value="Turquia">Turquia</Option>
                                        <Option value="Ucrânia">Ucrânia</Option>
                                        <Option value="Uganda">Uganda</Option>
                                        <Option value="Uruguai">Uruguai</Option>
                                        <Option value="Venezuela">Venezuela</Option>
                                        <Option value="Vietnã">Vietnã</Option>
                                        <Option value="Zaire">Zaire</Option>
                                        <Option value="Zâmbia">Zâmbia</Option>
                                        <Option value="Zimbábue">Zimbábue</Option>
                                    </Select>
                                </Form.Item>
                            </div>
                            <div className="bloco">
                                <h3 className="titulo-separador" style={{ marginBottom: "20px" }}>
                                    Filiação
                                </h3>
                                <Form.Item label="Nome da Mãe">
                                    <Input
                                        value={maeResponsavel}
                                        name="maeResponsavel"
                                        disabled={!podeAlterarDadosPessoais}
                                        onChange={this.handleChange}
                                    />
                                </Form.Item>
                                <Form.Item label="Profissão da Mãe">
                                    <Input
                                        value={maeProfissao}
                                        name="maeProfissao"
                                        disabled={!podeAlterarDadosPessoais}
                                        onChange={this.handleChange}
                                    />
                                </Form.Item>
                                <Form.Item label="Nome do Pai">
                                    <Input
                                        value={paiResponsavel}
                                        name="paiResponsavel"
                                        disabled={!podeAlterarDadosPessoais}
                                        onChange={this.handleChange}
                                    />
                                </Form.Item>
                                <Form.Item label="Profissão do Pai">
                                    <Input
                                        value={paiProfissao}
                                        name="paiProfissao"
                                        disabled={!podeAlterarDadosPessoais}
                                        onChange={this.handleChange}
                                    />
                                </Form.Item>
                            </div>
                            {this.context.responsaveis_entidade && (
                                <div className="bloco">
                                    <h3 className="titulo-separador" style={{ marginBottom: "20px" }}>
                                        Responsável
                                        <Tooltip
                                            className="info-icon"
                                            title="Através do e-mail poderá ser contatado pela gestão ou professores dos cursos deste usuário"
                                        >
                                            <Icon type="question-circle-o" />
                                        </Tooltip>
                                    </h3>
                                    <Form.Item label="Nome">
                                        <Input
                                            value={responsavelNome}
                                            name="responsavelNome"
                                            disabled={!podeAlterarDadosPessoais}
                                            onChange={this.handleChange}
                                        />
                                    </Form.Item>
                                    <Form.Item label="E-mail">
                                        {getFieldDecorator("responsavelEmail", {
                                            rules: [
                                                {
                                                    type: "email",
                                                    message: "Introduza um endereço de e-mail válido"
                                                }
                                            ],
                                            initialValue: responsavelEmail
                                        })(
                                            <Input
                                                name="responsavelEmail"
                                                className="input-50"
                                                disabled={!podeAlterarDadosPessoais}
                                                onChange={this.handleChange}
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item label="Telefone / Celular">
                                        <Input
                                            value={responsavelContacto}
                                            name="responsavelContacto"
                                            className="input-25"
                                            disabled={!podeAlterarDadosPessoais}
                                            onChange={this.handleChange}
                                        />
                                    </Form.Item>
                                </div>
                            )}
                            {podeAlterarDadosPessoais && (
                                <button
                                    className="botao-principal"
                                    style={{ padding: "10px 30px" }}
                                    onClick={e => {
                                        this.atualizarDados(e);
                                    }}
                                    disabled={iconLoading}
                                >
                                    {iconLoading ? <Icon type="loading" /> : null}
                                    Salvar
                                </button>
                            )}
                        </Form>
                    </div>
                </div>
            </div>
        );
    }
}

const FormDadosGerais = Form.create({ name: "form-minha-conta" })(DadosGerais);

export default FormDadosGerais;
